import styled from "styled-components";
import media from "styled-media-query";
import {Select,MenuItem as Option} from '@material-ui/core';
import AccountCircle from "@mui/icons-material/AccountCircle";

export const Filter = styled.div`
    width: fit-content;
    min-width:10rem;
    text-align:center;
    border-radius: 20px;
    padding: 1px 5px;
    height: 2rem !important;
    cursor:pointer;
    justify-content:space-between;
    font-size:16px;
    font-family:inherit;
`;

export const CircularProgressContainer = styled.div`
    display: flex;
    flex: 1;
    min-height: 150px;
    margin: 0 auto;
    justify-content:center;
    overflow: hidden;
`;

export const TableRoot = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0.5rem;
    padding: 0.5rem;
    width: 97%;
    height: 55vh;
    align-self: center;
    justify-content: space-between;
    overflow:auto;
    scrollbar-width:thin;
    scrollbar-color: #0D4CBE transparent;
    &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
    }
    &::-webkit-scrollbar-thumb {
            background: #0D4CBE;
            border-radius: 2px;
            cursor: pointer !important;
    }
    &::-webkit-scrollbar-track {
            background: transparent;
    }
`;

export const TableHeader = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0.2rem 0rem 0rem 0rem;
    width: 95%;
    align-self: center;
    min-height: 60px;
    height: 7%;
    justify-content: space-between;
    padding: 0rem 1rem 0rem 2rem;
`;

export const TableHeaderItem = styled.div`
    width: ${(props) => props.width};
    text-align: center;
    align-self: center;
    color: grey;
    font-family: "Prompt", sans-serif;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    font-weight: 400;
`;

export const TableSummary = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0rem 0rem 0rem 0rem;
    width: 100%;
    align-self: center;
    min-height: 50px;
    height: 6%;
    justify-content: space-between;
    flex-wrap: wrap;
`;

export const TableTotal = styled.div`
    display: flex;
    flex-direction: row;
    align-self: center;
    font-family: "Prompt", sans-serif !important;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 400;
    margin: 0 1rem;
`;

export const TableFilters = styled.div`
    justify-content: space-between;
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    align-self: center;
    font-family: "Prompt", sans-serif !important;
    font-size: 16px;
`;

export const AddButton = styled.button`
    color: rgba(0, 0, 0, 0.7) !important;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background: none;
    min-width: 110px;
    border-radius: 30px;
    border: 1px solid #bdbdbd;
    font-size: 14px !important;
    align-self: center;
    font-weight: 550;
    font-family: "Prompt", sans-serif !important;
    cursor: pointer;
    outline: none;
    &:hover {
        border-color: black;
    }
`;

export const TableFilterContainer = styled.div`
    margin: 0 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 30px;
    align-self: center;
    border-radius: 30px;
    border: 1px solid #bdbdbd;
    padding: 5px;
    font-size: 14px;
    &:hover {
        border-color: black;
    }
    cursor: pointer;
`;

export const SearchInput = styled.input`
    border: none;
    font-family: "Prompt", sans-serif !important;
    font-size: 13px;
    outline: none;
    margin-left: 0.3rem;
    align-self: center;
    width: 80%;
    &::placeholder {
        color: black;
    }
`;

export const TableRow = styled.div`
        display: flex;
        flex-direction: row;
        width: 95%;
	cursor: pointer;
        border-radius: 20px;
        /* background-color: #FFF; */
        box-shadow: 0 0 12px 0 rgba(0,0,0,0.1);
        margin: 0rem 0rem 1rem 0rem;
        justify-content: space-between;
        min-height: 50px;     
        padding: 0rem 1rem 0rem 2rem;
        &:hover{
                background: #f7f7f7;
        }

        ${media.between("medium", "large")`
                height: 50px;
        `}
`;

export const Product = styled.div`
    display: flex;
    flex-direction: row;
`;

export const PaginationContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;
    font-family: "Prompt", sans-serif !important;
    text-align: center;
`;

export const PageNumberContainer = styled.div`
    height: 41px;
    width: 45px;
    background-color: #fff;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
    color: #ff6f00;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: space-around;
    font-family: "Prompt", sans-serif !important;
    align-self: center;
    margin: 0 0 0 1rem;
`;

export const PageSwitch = styled.div`
    height: 41px;
    width: 45px;
    color: black;
    background-color: #fff;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: space-around;
    font-family: "Prompt", sans-serif !important;
    align-self: center;
    margin: 0 0 0 1rem;
    cursor: pointer;
`;

export const DialogRoot = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    color: white;
    font-family: "Prompt", sans-serif !important;
    font-size: 24px;
    display: flex;
    flex-direction: column;
`;

export const DialogInnerContainer = styled.div`
    width: 60%;
    color: white;
    font-family: "Prompt", sans-serif !important;
    font-size: 24px;
    display: flex;
    align-self: center;
    flex-direction: column;
    margin-top: 5rem;
`;

export const DialogTitle = styled.div`
    color: white;
    font-family: "Prompt", sans-serif !important;
    font-size: 24px;
    display: flex;
    align-self: center;
`;

export const ImageContainer = styled.div`
    height: 296px;
    width: 345px;
    background-color: #fefefe;
    opacity: 1 !important;
    fill-opacity: inherit;
    border-radius: 1rem;
`;

export const FormInputContainer = styled.div`
    width: 270.75px;
    height: 40px;
    border-radius: 20px;
    background: #fff;
    margin: 0.5rem 1rem 1rem 1rem;
    border: none;
    outline: none;
    font-family: "Prompt", sans-serif !important;
    font-size: 16px !important;
    /* padding: 0 0rem 0 0.5rem; */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const FormLabel = styled.div`
    color: white;
    font-family: "Prompt", sans-serif !important;
    font-size: 16px;
    margin: 0 1rem 0 1rem;
`;

export const FormInput = styled.input`
    width: 80%;
    align-self: center;
    font-family: "Prompt", sans-serif !important;
    font-size: 16px !important;
    padding: 0 1rem 0 1rem;
    background: none;
    border: none;
    outline: none;
`;

export const Status = styled.div`
    color: ${(props) =>
        props.type === "PENDING"
            ? "#FF6F00"
            : props.type === "CANCELLED"
            ? "#F70707"
            : props.type === "FULFILLED"
            ? "#00AD6F"
            : props.type === "PROCESSING"
            ? "#00AD6F"
            : props.type === "RETURNED"
            ? "#006EF0"
            : "#33E1FF"};
    border-radius: 30px;
    padding-left: 5px;
    padding-right: 5px;
    border: 1px solid #bdbdbd;
    height: 30px;
    font-size: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-weight: 500;
`;

export const StatusSelect = styled(Select)`
    width: 10rem;
    text-align: center;
    border-radius: 20px;
    /* box-shadow: 0 0 5px 0 grey; */
    padding: 1px 5px;
    height: 2rem !important;
    background-color: white;
    align-self: center;
    .MuiSelect-select:focus{
        background: transparent;
    }
`;

export const StyledMenuItem = styled(Option)`
    &:hover {
        background-color: rgba(0, 173, 111, 0.1);
        color: #00ad6f;
    }
    &.selected {
        background: white;
    }
`;


export const CustomerItem = styled.div`
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: solid 1px #c8c8c8;
    font-size: 16px;
    display: flex;
    font-family: "Prompt", sans-serif;
    font-weight: 300;
    flex-direction: row;
    word-break:break-word;
`;

export const CustomerTracking = styled.a`
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: solid 1px #c8c8c8;
    font-size: 16px;
    display: flex;
    font-family: "Prompt", sans-serif;
    font-weight: 300;
    flex-direction: row;
`;

export const CustomerOrderItem = styled.div`
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: solid 1px #c8c8c8;
    font-size: 16px;
    display: flex;
    font-family: "Prompt", sans-serif;
    font-weight: 300;
    flex-direction: row;
    cursor: pointer;
`;

export const ImgContainer = styled.img`
    width: 45px;
    height: 45px;
    margin-right: 0.5rem;
`;
export const ImgContainers = styled.img`
    width: 40px;
    height: 25px;
`;

export const CircleIcon = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background-color: #ff6f00;
    align-self: center;
`;

export const OrderLinesContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    max-height: 40vh;
    overflow:auto;
    scrollbar-width:thin;
    scrollbar-color: #0D4CBE transparent;
    &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
    }
    &::-webkit-scrollbar-thumb {
            background: #0D4CBE;
            border-radius: 2px;
            cursor: pointer !important;
    }
    &::-webkit-scrollbar-track {
            background: transparent;
    }
`;

export const OrderLineItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 0 20px 0;
    border-bottom: ${(props) => (!props.border ? "solid 1px lightgray" : "none")};
`;

export const OrderLineImg = styled.img`
    width: 100px;
    height: 100px;
    border: 1px solid lightgray;
    border-radius: 5px;
`;

export const MenuItem = styled.div`
    width: 100px;
    text-align: center;
    margin: 0 10px 0 10px;
    padding: 10px 0 10px 0;
    cursor: pointer;
    &:hover {
        text-shadow: 0px 0px 5px lightgrey;
    }
`;

export const SearchButton = styled.img`
    padding-right: 10px;
    padding-left: 10px;
    width: 15px;
    border-radius: 0 20px 20px 0;
    filter: brightness(0.8);
    cursor: pointer;
    color: #00AD6F;
`;

export const NoOption = styled.div`
    display: flex;
    align-items: center;
`;

export const AccountCircleIcon = styled(AccountCircle)`
    width: 45px !important;
    height: 45px !important;
    margin-right: 0.5rem;
    color: #535353;
`;